module.exports = require("string-template");